import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createMemberCampaign() {
  yield takeEvery(actions.CREATE_MEMBER_CAMPAIGN, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberCampaign`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_CAMPAIGN_ENDED });
    }
  });
}

function* searchMemberCampaigns() {
  yield takeEvery(actions.SEARCH_MEMBER_CAMPAIGNS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberCampaign?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_CAMPAIGNS_ENDED });
    }
  });
}

function* updateMemberCampaign() {
  yield takeEvery(actions.UPDATE_MEMBER_CAMPAIGN, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/memberCampaign`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_CAMPAIGN_ENDED });
    }
  });
}

function* deleteMemberCampaigns() {
  yield takeEvery(actions.DELETE_MEMBER_CAMPAIGNS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/memberCampaign`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_CAMPAIGNS_ENDED });
    }
  });
}

function* triggerMemberCampaign() {
  yield takeEvery(actions.TRIGGER_MEMBER_CAMPAIGN, function* (action) {
    const { id, onSuccess, isRetry } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/memberCampaign/${id}/trigger`,
        { isRetry },
        { timeout: 900000 }, // 15 minute
      );
      yield delay(3000);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.TRIGGER_MEMBER_CAMPAIGN_ENDED });
    }
  });
}

function* searchMemberCampaignMemberRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberCampaign/record/member?${parameters.toString()}`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS_END });
    }
  });
}

function* searchMemberCampaignTagMemberRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberCampaign/record/tagMember?${parameters.toString()}`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS_END });
    }
  });
}

function* searchTriggerRecords() {
  yield takeEvery(actions.SEARCH_TRIGGER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberCampaign/record/trigger?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_TRIGGER_RECORDS_ENDED });
    }
  });
}

function* getMemberCampaignTriggerRecordStatistics() {
  yield takeEvery(actions.GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS, function* (action) {
    const { memberCampaignId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberCampaign/${memberCampaignId}/record/statistics`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberCampaign),
    fork(searchMemberCampaigns),
    fork(updateMemberCampaign),
    fork(deleteMemberCampaigns),
    fork(triggerMemberCampaign),
    fork(searchMemberCampaignMemberRecords),
    fork(searchMemberCampaignTagMemberRecords),
    fork(searchTriggerRecords),
    fork(getMemberCampaignTriggerRecordStatistics),
  ]);
}
